import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyEventAccommodations = loadable(() => import(/* webpackChunkName: "content/accommodations" */ './EventAccommodationsApp'), 'EventAccommodationsApp');
